// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-wrapper {
  border-radius: 4px;
  border: 1px solid var(--sebrae-blue-6);
  background: var(--sebrae-white);
  display: flex;
  height: 40px;
  flex-shrink: 0;
  margin: 15px 0;
}
.step-wrapper button {
  display: block;
  width: 50%;
  height: 100%;
  color: var(--sebrae-gray);
  font-size: 16px;
}
.step-wrapper button:first-child {
  border-right: 1px solid var(--sebrae-blue-6);
}
.step-wrapper button.active {
  background-color: var(--sebrae-blue-6);
  color: var(--sebrae-white);
}`, "",{"version":3,"sources":["webpack://./src/components/step-component/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sCAAA;EACA,+BAAA;EAEA,aAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAAF;AAEE;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;AAAJ;AAEI;EACE,4CAAA;AAAN;AAGI;EACE,sCAAA;EACA,0BAAA;AADN","sourcesContent":[".step-wrapper {\n  border-radius: 4px;\n  border: 1px solid var(--sebrae-blue-6);\n  background: var(--sebrae-white);\n\n  display: flex;\n  height: 40px;\n  flex-shrink: 0;\n  margin: 15px 0;\n\n  button {\n    display: block;\n    width: 50%;\n    height: 100%;\n    color: var(--sebrae-gray);\n    font-size: 16px;\n\n    &:first-child {\n      border-right: 1px solid var(--sebrae-blue-6);\n    }\n\n    &.active {\n      background-color: var(--sebrae-blue-6);\n      color: var(--sebrae-white);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
